module.exports = __webpack_public_path__ + "img/tencent-oa-qrcode.fa8b6833.jpg";